global.version = "1.0.0";
global.i18 = {
    us: {
        "เมนูทั้งหมด": "All Menu",
        "ผลิตภัณฑ์แนะนำ": "Recommended Products",
        "ติดต่อเราได้ที่": "Contact Us",
        "เรามุ่งเน้นผลิตเตาเผาที่เป็นมิตรกับสิ่งแวดล้อม และสโลแกนของเราคือ “ใส่ใจสิ่งแวดล้อมอย่างแท้จริง”": "We focus on producing environmentally friendly incinerators, and our slogan is 'Truly Caring for the Environment.'",
        "คำอธิบาย": "Description",
        "หากสนใจสามารถติดต่อได้ที่": "If interested, please contact us at",
        "ตกลง": "Confirm",
        "ยกเลิก": "Cancel",
        "กรุณาชื่อ-นามสกุล": "Please enter your full name.",
        "กรุณากรอกอีเมล": "Please enter your email address.",
        "กรุณากรอกรูปแบบอีเมลให้ถูกต้อง": "Please enter the correct email format.",
        "กรุณากรอกเบอร์โทร": "Please enter your phone number.",
        "กรุณากรอกเบอร์โทรให้ครบถ้วน": "Please enter your complete phone number.",
        "กรุณากรอกเบอร์โทรให้ถูกต้อง": "Please enter the correct phone number.",
        "สำเร็จ": "Completed",
        "ขอบคุณที่ติดต่อเรา! เราจะติดต่อกลับโดยเร็วที่สุด": "Thank you for contacting us! We will get back to you as soon as possible.",
        "ภาคเหนือ": "North",
        "ภาคกลาง": "Central",
        "ภาคตะวันออกเฉียงเหนือ": "Northern East",
        "ภาคใต้": "South",
        "หน่วยงานเอกชน": "Foreigner Customer",
        "ลูกค้าต่างประเทศ": "Private Organization",
        "หน้าแรก": "Home",
        "เกี่ยวกับบริษัท": "About Us",
        "สินค้าทั้งหมดจาก บริษัท เอเชีย อีโค เอิร์ท จำกัด": "All incinerator Models from Sankyo Incinerator Co., Ltd.",
        "ขอใบเสนอราคา": "Get Quotes",
        "อ่านเพิ่มเติม": "Read More",
        "รายละเอียด": "More Details",
        "สาธิตสินค้า": "Products Demonstration",
        "สินค้าอื่นๆ": "All Models",
        "ดูสินค้าเพิ่มเติม": "All Models",
        "สินค้า": "Products",
        "มาตรฐานและงานวิจัย": "Research",
        "ลูกค้า": "Customers",
        "ติดต่อเรา": "Contact Us",
        "โทรสาร": "Fax",
        "โทรได้ที่": "Phone",
        "สำนักงานใหญ่": "Head Office",
        "อีเมล": "Email",
        "เว็บไซต์": "Website",
        "เรานำเสนอเตาเผาขยะคุณภาพสูง มุ่งเน้นการผลิตเตาเผาขยะที่ไม่ก่อมลพิษ “จริงใจ ห่วงใย สิ่งแวดล้อม”": "We offer high quality, professional Incinerators and Repair Services",
        "ชื่อ - นามสกุล": "Name",
        "ชื่อ-นามสกุล": "Name",
        "เบอร์โทรศัพท์": "Phone",
        "ข้อความที่ต้องการติดต่อ": "Message",
        "ส่งข้อความ": "Send",
        "ต้องกรอกฟิลด์ที่มีเครื่องหมาย": "Fields marked are required",
        "เลือกรุ่นที่ต้องการใบเสนอราคา": "Select Incimerator model",
        "คำถามหรือความคิดเห็น": "Additional Questions or Comments",
        "ทั้งหมด": "All",
        "ไม่ใช้พลังงานไฟฟ้าและเชื้อเพลิง": "Does not use electricity and fuel",
        "ใช้พลังงานไฟฟ้าและเชื้อเพลิง": "Use electricity and fuel",
        "คุณสมบัติทั่วไป": "SPECIFICATION",
        "ข้อมูลทั่วไป": "General Information",
        "คุณสมบัติเฉพาะ รุ่น": "Specification",
        "ระบบของเตา": "Incineration System",
        "ขนาด (ประมาณ)": "Size (Estimate)",
        "น้ำหนัก (ประมาณ)": "Weight (Estimate)",
        "ปริมาณที่เผาได้/ ชม.": "Disposal Capacity/hr",
        "อัตราส่วนของขยะที่เผาได้ (ขยะเปียก:แห้ง)": "The waste combustion percentage (Wet: Dry)",
        "ห้องเผาไหม้": "Combustion Chamber",
        "อุณหภูมิในขณะเผาไหม้": "Combustion temperature",
        "เชื้อเพลิงในการเผาไหม้": "Fuel Combustion",
        "ระบบเติมอากาศ": "Air Supply",
        "อายุการใช้งาน": "Useful Life",
        "การรับประกัน": "Warranty",
        "ดาวน์โหลดแคตตาล็อก": "Download Catalog",
        "ดาวน์โหลดงานวิจัย": "Download Research",
        "แจ้งเตือน": "Alert"
    },
    jp: {
                "เมนูทั้งหมด": "すべてのメニュー",
        "ผลิตภัณฑ์แนะนำ": "おすすめ製品",
        "ติดต่อเราได้ที่": "お問い合わせ",
        "เรามุ่งเน้นผลิตเตาเผาที่เป็นมิตรกับสิ่งแวดล้อม และสโลแกนของเราคือ “ใส่ใจสิ่งแวดล้อมอย่างแท้จริง”": "私たちは環境に優しい焼却炉の製造に注力しており、スローガンは「環境への真の配慮」です。",
        "คำอธิบาย": "説明",
        "หากสนใจสามารถติดต่อได้ที่": "ご興味のある方は、以下までご連絡ください。",
        "ตกลง": "確認",
        "ยกเลิก": "キャンセル",
        "กรุณาชื่อ-นามสกุล": "お名前（フルネーム）を入力してください。",
        "กรุณากรอกอีเมล": "メールアドレスを入力してください。",
        "กรุณากรอกรูปแบบอีเมลให้ถูกต้อง": "正しいメールアドレスの形式を入力してください。",
        "กรุณากรอกเบอร์โทร": "電話番号を入力してください。",
        "กรุณากรอกเบอร์โทรให้ครบถ้วน": "電話番号（フルネーム）を入力してください。",
        "กรุณากรอกเบอร์โทรให้ถูกต้อง": "正しい電話番号を入力してください。",
        "สำเร็จ": "完了",
        "ขอบคุณที่ติดต่อเรา! เราจะติดต่อกลับโดยเร็วที่สุด": "お問い合わせいただきありがとうございます。できるだけ早くご連絡いたします。",
        "ภาคเหนือ": "北部",
        "ภาคกลาง": "中部",
        "ภาคตะวันออกเฉียงเหนือ": "北東部",
        "ภาคใต้": "南部",
        "หน่วยงานเอกชน": "外国人のお客様",
        "ลูกค้าต่างประเทศ": "民間団体",
        "หน้าแรก": "ホーム",
        "เกี่ยวกับบริษัท": "会社概要",
        "สินค้าทั้งหมดจาก บริษัท เอเชีย อีโค เอิร์ท จำกัด": "三共焼却炉株式会社の全焼却炉機種",
        "ขอใบเสนอราคา": "見積もり依頼",
        "อ่านเพิ่มเติม": "詳細を読む",
        "รายละเอียด": "詳細",
        "รายละเขอใบเสนอราคาอียด": "詳細",
        "สาธิตสินค้า": "製品デモ",
        "สินค้าอื่นๆ": "全機種",
        "ดูสินค้าเพิ่มเติม": "全機種",
        "สินค้า": "製品",
        "มาตรฐานและงานวิจัย": "調査",
        "ลูกค้า": "お客様",
        "ติดต่อเรา": "お問い合わせ",
        "โทรได้ที่": "お問い合わせ",
        "โทรสาร": "ファックス",
        "สำนักงานใหญ่": "本社",
        "อีเมล": "Eメール",
        "เว็บไซต์": "ウェブサイト",
        "เรานำเสนอเตาเผาขยะคุณภาพสูง มุ่งเน้นการผลิตเตาเผาขยะที่ไม่ก่อมลพิษ “จริงใจ ห่วงใย สิ่งแวดล้อม”": "高品質でプロフェッショナルな焼却炉と修理サービスを提供しています",
        "ชื่อ - นามสกุล": "氏名",
        "ชื่อ-นามสกุล": "氏名",
        "เบอร์โทรศัพท์": "電話番号",
        "ข้อความที่ต้องการติดต่อ": "メッセージ",
        "ส่งข้อความ": "送信",
        "ต้องกรอกฟิลด์ที่มีเครื่องหมาย": "マークされている項目は必須です",
        "เลือกรุ่นที่ต้องการใบเสนอราคา": "焼却炉機種を選択",
        "คำถามหรือความคิดเห็น": "追加のご質問またはご意見",
        "ทั้งหมด": "すべて",
        "ไม่ใช้พลังงานไฟฟ้าและเชื้อเพลิง": "電気と燃料を使用しない",
        "ใช้พลังงานไฟฟ้าและเชื้อเพลิง": "電気と燃料を使用する",
        "คุณสมบัติทั่วไป": "仕様",
        "ข้อมูลทั่วไป": "一般情報",
        "คุณสมบัติเฉพาะ รุ่น": "仕様",
        "ระบบของเตา": "焼却システム",
        "ขนาด (ประมาณ)": "サイズ（概算）",
        "น้ำหนัก (ประมาณ)": "重量（概算）",
        "ปริมาณที่เผาได้/ ชม.": "処理能力/時間",
        "อัตราส่วนของขยะที่เผาได้ (ขยะเปียก:แห้ง)": "廃棄物燃焼率（湿式）",
        "ห้องเผาไหม้": "燃焼室",
        "อุณหภูมิในขณะเผาไหม้": "燃焼温度",
        "เชื้อเพลิงในการเผาไหม้": "燃料燃焼",
        "ระบบเติมอากาศ": "空気供給",
        "อายุการใช้งาน": "耐用年数",
        "การรับประกัน": "保証",
        "ดาวน์โหลดแคตตาล็อก": "カタログをダウンロード",
        "ดาวน์โหลดงานวิจัย": "調査資料をダウンロード",
        "แจ้งเตือน": "アラート"
    },
    cn: {
         "เมนูทั้งหมด": "所有菜单",
        "ผลิตภัณฑ์แนะนำ": "推荐产品",
        "ติดต่อเราได้ที่": "联系我们",
        "เรามุ่งเน้นผลิตเตาเผาที่เป็นมิตรกับสิ่งแวดล้อม และสโลแกนของเราคือ “ใส่ใจสิ่งแวดล้อมอย่างแท้จริง”": "我们专注于生产对环境友好的焚烧炉，我们的口号是“真正关心环境”。",

        "คำอธิบาย": "描述",
        "หากสนใจสามารถติดต่อได้ที่": "如果有兴趣，请联系我们",
        "ตกลง": "确认",
        "ยกเลิก": "取消",
        "กรุณาชื่อ-นามสกุล": "请输入您的全名。",
        "กรุณากรอกอีเมล": "请输入您的电子邮件地址。",
        "กรุณากรอกรูปแบบอีเมลให้ถูกต้อง": "请输入正确的电子邮件地址格式。",
        "กรุณากรอกเบอร์โทร": "请输入您的电话号码。",
        "กรุณากรอกเบอร์โทรให้ครบถ้วน": "请输入完整的电话号码。",
        "กรุณากรอกเบอร์โทรให้ถูกต้อง": "请输入正确的电话号码。",
        "สำเร็จ": "完成",
        "ขอบคุณที่ติดต่อเรา! เราจะติดต่อกลับโดยเร็วที่สุด": "感谢您联系我们！我们会尽快回复您。",
        "ภาคเหนือ": "北部",
        "ภาคกลาง": "中部",
        "ภาคตะวันออกเฉียงเหนือ": "东北部",
        "ภาคใต้": "南部",
        "หน่วยงานเอกชน": "外国客户",
        "ลูกค้าต่างประเทศ": "私人机构",
        "หน้าแรก": "首页",
        "เกี่ยวกับบริษัท": "关于我们",
        "สินค้าทั้งหมดจาก บริษัท เอเชีย อีโค เอิร์ท จำกัด": "三共焚烧株式会社所有焚烧炉型号",
        "ขอใบเสนอราคา": "获取报价",
        "อ่านเพิ่มเติม": "了解更多",
        "รายละเอียด": "更多详情",
        "สาธิตสินค้า": "产品演示",
        "สินค้าอื่นๆ": "所有型号",
        "ดูสินค้าเพิ่มเติม": "所有型号",
        "สินค้า": "产品",
        "มาตรฐานและงานวิจัย": "研究",
        "ลูกค้า": "客户",
        "ติดต่อเรา": "联系我们",
        "โทรได้ที่": "联系我们",
        "โทรสาร": "传真",
        "สำนักงานใหญ่": "总部",
        "อีเมล": "电子邮件",
        "เว็บไซต์": "网站",
        "เรานำเสนอเตาเผาขยะคุณภาพสูง มุ่งเน้นการผลิตเตาเผาขยะที่ไม่ก่อมลพิษ “จริงใจ ห่วงใย สิ่งแวดล้อม”": "我们提供高质量、专业的焚烧炉及维修服务",
        "ชื่อ - นามสกุล": "姓名",
        "ชื่อ-นามสกุล": "姓名",
        "เบอร์โทรศัพท์": "电话",
        "ข้อความที่ต้องการติดต่อ": "留言",
        "ส่งข้อความ": "发送",
        "ต้องกรอกฟิลด์ที่มีเครื่องหมาย": "标有星号的字段为必填项",
        "เลือกรุ่นที่ต้องการใบเสนอราคา": "选择焚烧炉型号",
        "คำถามหรือความคิดเห็น": "其他问题或意见",
        "ทั้งหมด": "全部",
        "ไม่ใช้พลังงานไฟฟ้าและเชื้อเพลิง": "不使用电力和燃料",
        "ใช้พลังงานไฟฟ้าและเชื้อเพลิง": "使用电力和燃料",
        "คุณสมบัติทั่วไป": "规格",
        "ข้อมูลทั่วไป": "一般信息",
        "คุณสมบัติเฉพาะ รุ่น": "规格",
        "ระบบของเตา": "焚烧系统",
        "ขนาด (ประมาณ)": "尺寸（估算）",
        "น้ำหนัก (ประมาณ)": "重量（估算）",
        "ปริมาณที่เผาได้/ ชม.": "每小时处理能力",
        "อัตราส่วนของขยะที่เผาได้ (ขยะเปียก:แห้ง)": "废物燃烧率（湿式）",
        "ห้องเผาไหม้": "燃烧室",
        "อุณหภูมิในขณะเผาไหม้": "燃烧温度",
        "เชื้อเพลิงในการเผาไหม้": "燃料燃烧",
        "ระบบเติมอากาศ": "空气供应",
        "อายุการใช้งาน": "使用寿命",
        "การรับประกัน": "保修",
        "ดาวน์โหลดแคตตาล็อก": "下载产品目录",
        "ดาวน์โหลดงานวิจัย": "下载研究报告",
        "แจ้งเตือน": "提醒"
    }
}